import React from 'react'
import { Box, Container, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'
import { useIntl } from 'react-intl'
import { useEffect } from 'react'

import { useCombos, useManualCombo } from '../../../features/combos'
import { EEPPHeader } from '../../../features/eepp/components/header'
import { EEPPTable } from '../../../features/eepp/components/table'
import { useEEPPCalls } from '../../../features/eepp/hooks'
import { useURLLoader } from '../../../features/loader/hooks/loader.hook'
import { useGuildCalls } from '../../../features/guilds/hooks/guilds-calls.hook'
import { eeppStyles } from './eepp.styles'

export const EEPPPage = withStyles(eeppStyles)(({ classes }) => {
    const { getEEPP } = useEEPPCalls()
    const { formatMessage } = useIntl()
    const { getGuilds } = useGuildCalls()
    const { setManualCombo } = useManualCombo()

    useCombos(['cnae', 'cod_zona_zeus'])
    useEffect(() => {
        getGuilds({ params: { _num_x_pagina: 0 } }).then(({ data }) => {
            const comboData = data.gremios.map((el) => ({
                key: '' + el.gremio_id,
                value: el.nombre,
            }))
            setManualCombo('guilds', comboData)
        })
    }, [])
    useURLLoader({
        defaultChoices: { _pagina: 1, _num_x_pagina: 10 },
        minRefreshMs: 1000,
        identifier: 'eepp',
        call: getEEPP
    })

    return (
        <Container className={classes.container} maxWidth={false}>
            <Box mb={2}>
                <Typography variant="h4" color="textSecondary">
                    {formatMessage({ id: 'pages.eepp.title' })}
                </Typography>
            </Box>
            <Box mb={2}>
                <EEPPHeader />
            </Box>
            <Box>
                <EEPPTable />
            </Box>
        </Container>
    )
})